import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../common/mixins';

const rules = ({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  padding: `0 ${theme.margin.xxlarge}`,
  alignItems: 'center',
  extend: [
    largeScreen({
      padding: `0 ${theme.margin.large}`,
    }),
    smallScreen({
      padding: `0 ${theme.margin.medium}`,
      height: '24px',
    }),
  ],
});

const ControlsContainer = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

ControlsContainer.propTypes = {
  children: PropTypes.node,
};

export default React.memo(ControlsContainer);
